/**
 * Darstellung der Oberfläche: Farbschema und Hintergrund. Die Wahl liegt im
 * Gerät und zusätzlich im Konto; Server und Oberfläche prüfen sie hier
 * gleich.
 */

/** Wahl des Farbschemas. */
export const THEME_CHOICES = ['system', 'light', 'dark'] as const;
export type ThemeChoice = (typeof THEME_CHOICES)[number];

/** Wählbare Hintergründe; die Muster stehen in apps/web/src/styles.css. */
export const BACKGROUND_CHOICES = ['plain', 'warm', 'linen', 'gingham', 'tiles', 'dots', 'herbs'] as const;
export type BackgroundChoice = (typeof BACKGROUND_CHOICES)[number];

/** Eine vollständige Wahl. */
export interface Appearance {
  readonly theme: ThemeChoice;
  readonly background: BackgroundChoice;
}

/** Vorgabe ohne eigene Wahl. */
export const DEFAULT_APPEARANCE: Appearance = { theme: 'system', background: 'plain' };

/**
 * Liest eine Wahl aus unbekannten Daten.
 * @returns null, wenn Farbschema oder Hintergrund fehlen oder unbekannt sind.
 */
export function parseAppearance(value: unknown): Appearance | null {
  if (typeof value !== 'object' || value === null) {
    return null;
  }
  const record = value as Record<string, unknown>;
  const theme = THEME_CHOICES.find((entry) => entry === record.theme);
  const background = BACKGROUND_CHOICES.find((entry) => entry === record.background);
  return theme === undefined || background === undefined ? null : { theme, background };
}
